export const basepath = "apps/imagery-explorer";

// export const basepath = "";
